import { CATEGORY } from 'modules/analytics-provider/analytics-provider.constants';

export const TEXT_KEYS = {
    CAPTION: 'friend-referral-program',
    TITLE: 'invitation-page__title',
    DESCRIPTION: 'invitation-page__description',
    BUTTON_ACCEPT: 'invitation-page__button-text',
    WARNING: 'invitation-page__warning'
};

export const GET_ANALYTICS_INVITATION_INIT_DATA = () => ({
    flowStep: 'invitation',
    category: CATEGORY.DISPLAY,
    action: 'invitation page'
});

export const GET_ANALYTICS_INVITATION_ACCEPT = (action: string) => ({
    flowStep: 'invitation',
    category: CATEGORY.ACTION,
    action
});
